import styled from '@emotion/styled';
import { ButtonLinkWithIcon } from '@zoopla/blueprint-button-with-icon';

export const StyledMapIconLink = styled(ButtonLinkWithIcon)(`
    min-width: unset;
    padding-left: 0;
    padding-right: 0;
`);
